class ToggleFiltersView extends HTMLElement {
  constructor() {
    super();

    this.filtersVisible = false;

    this.addEventListener('click', this.toggle.bind(this));

    requestAnimationFrame(() => this.applyState());
  }

  applyState() {
    const section = this.closest('.shopify-section');
    const mainFilters = section?.querySelector('#main-collection-filters');
    const productGrid = section?.querySelector('#ProductGridContainer #product-grid');
    const title = this.querySelector('[btn-title]');

    if (!mainFilters || !productGrid || !title) return;

    if (this.filtersVisible) {
      // SHOW filters
      mainFilters.classList.remove('deactive');
      mainFilters.classList.add('active');
      mainFilters.style.setProperty('--max-width', `${mainFilters.scrollWidth + 40}px`);

      productGrid.classList.remove('grid--4-col-desktop');
      productGrid.classList.add('grid--3-col-desktop');

      title.textContent = 'Hide Filters';
    } else {
      // HIDE filters
      mainFilters.classList.add('deactive');
      mainFilters.classList.remove('active');
      mainFilters.style.setProperty('--max-width', '0px');

      productGrid.classList.remove('grid--3-col-desktop');
      productGrid.classList.add('grid--4-col-desktop');

      title.textContent = 'Filters';
    }
  }

  toggle() {
    this.filtersVisible = !this.filtersVisible;
    this.applyState();
  }
}

customElements.define('toggle-filters-view', ToggleFiltersView);